import { render, staticRenderFns } from "./OrgHomeFees.vue?vue&type=template&id=7cc65f88&scoped=true&"
import script from "./OrgHomeFees.vue?vue&type=script&lang=js&"
export * from "./OrgHomeFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc65f88",
  null
  
)

export default component.exports